import './static/css/alerts.css';

const ErrorAlert = ({ error }) => {
     return (
          <div>
               {
                    error &&
                    <div class="alert alert-danger border-5 border-bottom-0 border-end-0 border-top-0 fixed-top m-auto mt-5 rounded-0" role="alert">
                         <label class="lead text-white title">
                              Aten&ccedil;&atilde;o!
                              <br />
                              {error}
                         </label>
                    </div>
               }
          </div>
     );
}

export {
     ErrorAlert
};